import { SET_USER_DETAILS } from './action-types';

export default function reducer(state, action) {
    if (action.type.startsWith('@')) {
        return { ...state, [action.type]: action.payload };
    }
    if (action.type === SET_USER_DETAILS) {
        return { ...state, user: action.payload };
    }
}
